var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._g({staticClass:"btn scroll-line__item",class:_vm.active ? 'btn--primary' : 'btn--blank',attrs:{"loading":_vm.loading}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }